import { BusinessCategory, BusinessCategoryLabel } from './types';
export function getLabelForMerchantBusinessCategory(category) {
  switch (category) {
    case BusinessCategory.BeautyPersonalCare:
      return BusinessCategoryLabel.BeautyPersonalCare;
    case BusinessCategory.CharitiesEducationMembership:
      return BusinessCategoryLabel.CharitiesEducationMembership;
    case BusinessCategory.FoodDrink:
      return BusinessCategoryLabel.FoodDrink;
    case BusinessCategory.HomeRepair:
      return BusinessCategoryLabel.HomeRepair;
    case BusinessCategory.LeisureEntertainment:
      return BusinessCategoryLabel.LeisureEntertainment;
    case BusinessCategory.PetCare:
      return BusinessCategoryLabel.PetCare;
    case BusinessCategory.ProfessionalServices:
      return BusinessCategoryLabel.ProfessionalServices;
    case BusinessCategory.Retail:
      return BusinessCategoryLabel.Retail;
    case BusinessCategory.Transportation:
      return BusinessCategoryLabel.Transportation;
    case BusinessCategory.Fitness:
    case BusinessCategory.Healthcare:
    case BusinessCategory.HealthcareFitness:
      return BusinessCategoryLabel.HealthcareFitness;
    case BusinessCategory.CasualUse:
    case BusinessCategory.Default:
    default:
      return BusinessCategoryLabel.CasualUse;
  }
}